const RESOURCE_NAME = "entities/teacherRatings";

export default {};
